import type { SidecarOperatingSystem } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const sidecarRegisterAtom = createMutationAtomFactory(
  'settings.sidecarRegister',
  (params: {
    sidecarId: string;
    publicKey: string;
    facilityId: string;
    name?: string | null;
    operatingSystem?: SidecarOperatingSystem | null;
    operatingSystemVersion?: string | null;
  }) => ({
    iotSidecarRegister: {
      __args: {
        sidecarId: params.sidecarId,
        publicKey: params.publicKey,
        facilityId: params.facilityId,
        name: params.name,
        operatingSystem: params.operatingSystem,
        operatingSystemVersion: params.operatingSystemVersion,
      },
      id: true,
      name: true,
      status: true,
    },
  }),
);
